import { OepDocument, MultiLanguage, OnlinePaymentInfo, ProcessConfigPayExemption, PayExemptionCatalog } from '@/Domain/Entities';
import { FileTypes } from '@/Domain/enum';

export default class ProcessRequisites {
    private _id: string;
    private _title: MultiLanguage;
    private _statusBool: boolean;
    private _reason: MultiLanguage;
    private _documents: OepDocument[];
    private _allowsDocument: boolean;
    private _type: number;
    private _onlinePaymentInfo: OnlinePaymentInfo | null;
    // CON-451: Guid del descuento elegido, ya no el bit-flag.
    private _payExemptionType: string | null;
    private _payExemptionTitle: MultiLanguage;
    private _isOptional: boolean;

    public get id() {
        return this._id;
    }
    public get title(): MultiLanguage {
        return this._title;
    }
    public set title(title: MultiLanguage) {
        this._title = title;
    }
    public get allowsDocument() {
        return this._allowsDocument;
    }
    public get documents() {
        return this._documents;
    }
    public set documents(documents: OepDocument[]) {
        this._documents = documents;
    }

    public get statusBool() {
        return this._statusBool;
    }
    public set statusBool(statusBool: boolean) {
        this._statusBool = statusBool;
    }

    public get reason(): MultiLanguage {
        return this._reason;
    }

    public set reason(reason: MultiLanguage) {
        this._reason = reason;
    }

    public get type() {
        return this._type;
    }
    public set type(type: number) {
        this._type = type;
    }

    public get onlinePaymentInfo() {
        return this._onlinePaymentInfo;
    }

    public set onlinePaymentInfo(onlinePaymentInfo: OnlinePaymentInfo | null) {
        this._onlinePaymentInfo = onlinePaymentInfo;
    }

    public get payExemptionType() {
        return this._payExemptionType;
    }

    public get payExemptionTitle(): MultiLanguage {
        return this._payExemptionTitle;
    }

    public get isOptional() {
        return this._isOptional;
    }
    public set isOptional(isOptional: boolean) {
        this._isOptional = isOptional;
    }

    constructor(data: any, processConfigurationPayExemptions: ProcessConfigPayExemption[]) {
        this._id = data.id;
        this._title = data.title ? new MultiLanguage(data.title) : new MultiLanguage({});
        this._documents = data.files;
        this._statusBool = data.statusBool;
        this._reason = new MultiLanguage(data.reason);
        this._allowsDocument = data.allowsDocument;
        this._reason = new MultiLanguage(data.rejectionReason);
        this._type = data.type;
        this._onlinePaymentInfo = data.onlinePaymentInfo ? new OnlinePaymentInfo(data.onlinePaymentInfo) : null;
        // CON-451: `payExemption.payExemptionType` es el Guid del descuento (id de
        // ProcessConfigurationPayExemption), no el antiguo bit, así que el cruce con el catálogo es
        // por `id`. Si el descuento no estuviese en el catálogo el título queda vacío en lugar de
        // reventar: antes un `[0].title` sin guarda tumbaba la carga entera del panel.
        this._payExemptionType = data.payExemption ? data.payExemption.payExemptionType : null;
        const selectedPayExemption = data.payExemption
            ? processConfigurationPayExemptions.find(payExemption => PayExemptionCatalog.sameId(payExemption.id, this._payExemptionType))
            : null;
        this._payExemptionTitle = selectedPayExemption
            ? new MultiLanguage(selectedPayExemption.title)
            : new MultiLanguage({});
        this._isOptional = data.isOptional;
    }

    public isExcluded(): boolean {
        return this.statusBool === false || this.type === FileTypes.enum.OTHER && this.documents.length > 0;
    }

    public toServer() {
        return {
            id: this.id,
            statusBool: this._statusBool,
            rejectionReason: this.reason,
            isOptional: this.isOptional
        };
    }

}
